import {Component, ViewChild, Output, EventEmitter, Input, ElementRef} from '@angular/core';
import {TimepickerConfig, ModalDirective} from "ng2-bootstrap";
import {LeadsService} from "../../models/leads/leads.service";
import {ToasterService} from "angular2-toaster";
import * as moment from 'moment';
import {ClientsService} from "../../models/clients/clients.service";
import {ValidationService} from "../../services/validation.service";


export function getTimePickerConfig(): TimepickerConfig {
    return Object.assign(new TimepickerConfig(), {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true
    });
}

export interface ScheduleForm {
    date: Date,
    time: Date,
    notes?: string
}
export interface ScheduleModel {
    schedule_time: string,
    notes?: string
}

@Component({
    selector: 'scheduled-callbacks',
    templateUrl: 'scheduled-callbacks.template.html',
    exportAs: 'createSchedule',
    styleUrls:['scheduled-callbacks.component.css'],
    providers: [{provide: TimepickerConfig, useFactory: getTimePickerConfig}]
})
export class ScheduledCallbacksComponent {

    public today: Date = new Date();
    public isFutureTime: boolean = true;
    public invalidTime: boolean = false;

    public $scheduleForm;

    private model: ScheduleModel = ScheduledCallbacksComponent.getEmptyModel();
    private form: ScheduleForm = ScheduledCallbacksComponent.getEmptyForm();
    private personData: any;

    @Input('serviceSave') public serviceSave: LeadsService | ClientsService;
    @ViewChild('modalSchedule') public modalSchedule: ModalDirective;
    @Output() onSaveSchedule: EventEmitter<any> = new EventEmitter<any>();


    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        private toasterService: ToasterService,
        protected el: ElementRef,
        protected validationService: ValidationService
    ) {

    }

    ngOnInit() {

    }

    ngAfterViewInit() {
        this.$scheduleForm = $('[name="schedule-form"]', this.el.nativeElement);
        this.validateForm();
    }

    // ===========================================================
    // Actions
    // ===========================================================

    public validateInputTime (time) {
        if (time.hours > 12 || time.minutes > 59) {
            this.invalidTime = true;
            return;
        }
        this.invalidTime = false;
    }
    public validateTime(){

        //past
        if (moment().startOf('day').unix() > moment(this.form['date']).startOf('day').unix()) {
            this.isFutureTime = false;
            return false;

        }

        //today
        if(moment().startOf('day').unix() == moment(this.form['date']).startOf('day').unix()){
            let time = moment(this.form.time.toTimeString(), ["HH:mm::ss"]);

            if(moment().diff(time, 'minute') > 0){
                this.isFutureTime = false;
                return false;
            }
        }
        this.isFutureTime = true;
        return true;
    }

    public hide() {
        this.modalSchedule.hide();
    }

    public show(person) {
        this.form = ScheduledCallbacksComponent.getEmptyForm();
        this.$scheduleForm.data('validator').resetForm();

        this.personData = Object.create(person);

        if(true || this.personData.lead_id){
            this.personData.notes = '';
        }
        this.personData.schedule_time = null;

        if(this.personData.schedule_time !== null){
            let localTime = moment.utc(this.personData.schedule_time).local().format('YYYY-MM-DD HH:mm:ss');

            this.form.date = new Date(localTime);
            this.form.time = new Date(localTime);
            this.form.notes = this.personData.notes;
        }

        this.modalSchedule.show();
    }


    // ===========================================================
    // Functions
    // ===========================================================

    private validateForm() {
        this.$scheduleForm
            .validate({
                rules: {
                    time: {
                        required: true,
                    },
                    date: {
                        required: true,
                    },
                    notes: {
                        minlength: 1,
                        maxlength: 200
                    },
                },
                submitHandler: (form) => {

                    if(!this.validateTime()){
                        return false;
                    }
                    this.$scheduleForm.find('input,button').prop("disabled", true);

                    this.model.schedule_time = ScheduledCallbacksComponent.getDateTimeFromForm(this.form.date, this.form.time);
                    this.model.notes = this.form.notes;

                    this.serviceSave.setSchedule(this.personData.id, this.model)
                        .subscribe(
                            () => {
                                let message = 'Schedule ' + (this.personData.visible == LeadsService.LEAD_VISIBLE_SCHEDULE ? 'updated' : 'created');

                                this.$scheduleForm.find('input,button').prop("disabled", false);
                                this.modalSchedule.hide();
                                this.toasterService.pop('success', 'Success', message);

                                this.onSaveSchedule.emit();
                            },
                            (error) => {
                                this.$scheduleForm.find('input,button').prop("disabled", false);
                                this.validationService.showError(error, form);
                            });
                    return false;
                }
            });
    }


    static getEmptyForm(): ScheduleForm {
        return {
            date: new Date(),
            time: new Date(),
            notes: ''
        }
    }

    static getEmptyModel(): ScheduleModel {
        return {
            schedule_time: ''
        }
    }

    static getDateTimeFromForm(date: Date, time: Date){

        let dateResult = new Date(date.getFullYear(), date.getMonth(), date.getDate(), time.getHours(), time.getMinutes());

        if(dateResult){
            return moment(dateResult).utc().format('YYYY-MM-DD HH:mm:ss').toString();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/modules/scheduled-callbacks/scheduled-callbacks.component.ts